export { HistorycalDataIcon } from './HistorycalDataIcon';
